import _ from 'lodash';
import React from 'react';

import { getCurrentPageName } from 'common/js/helpers';
import LazyImage from 'webshop/js/lazyimage';
import ProductHelpers from 'webshop/js/product-helpers';
import ProductRowMixin from 'webshop/js/product-row-mixin';

var WheelList = React.createClass({
    findCartCount: function(id) {
        var count = 0;
        if (!this.props.cartData) {
            return count;
        }
        var cartRow = _.findWhere(this.props.cartData.rows, {product: id});
        if (cartRow) {
            count = cartRow.count;
        }
        return count;
    },
    createRow: function (product, idx) {
        var cartCount = this.findCartCount(product.id),
            initialCount = product.product_type == 'wheel_set'? 1:4;

        return <WheelListBox {...product} key={product.id} cart_count={cartCount} initial_count={initialCount} car={this.props.car} position={idx}/>;
    },
    render: function() {
        return <div>{this.props.products && this.props.products.map(this.createRow)}</div>;
    }
});

var WheelListBox = React.createClass({
    mixins: [ProductRowMixin],
    render: function () {
        var energyLabel,
            wetGripLabel,
            noiseLevelLabel,
            noiseDBLabel,
            deliveryTime,
            className,
            pcd = this.props.pcd,
            is_wheel_set = this.props.product_type == 'wheel_set',
            non_stock_product = this.props.non_stock_product,
            wheel_set_text = is_wheel_set ? 'Sarja ' : '',
            interval = function() {
                if(non_stock_product) return 2;
                if(is_wheel_set) return 1;
                return 4;
            }(),
            countAvailable = non_stock_product ? this.props.supplier_stock - this.props.cart_count : this.props.stock_total - this.props.cart_count;

        if (this.props.energy_label) {
            className = "eu-label energy-label color-" + this.props.energy_label ;
            energyLabel = <span className={className}>{this.props.energy_label}</span>;
        }
        if (this.props.wet_grip_label) {
            className = "eu-label wet-grip-label color-" + this.props.wet_grip_label ;
            wetGripLabel = <span className={className}>{this.props.wet_grip_label}</span>;
        }
        if (this.props.noise_level) {
            var label_table = ['-', 'A', 'B', 'C'];
            var noise_level_as_label = label_table[this.props.noise_level];
            className = "eu-label noise-level-label color-" + noise_level_as_label;
            noiseLevelLabel = <span className={className}>{noise_level_as_label}</span>;
        }
        if (this.props.noise_dB) {
            noiseDBLabel = <span className="eu-label noise-db-label">{this.props.noise_dB} dB</span>;
        }
        if (this.props.pcd2) {
            pcd = <span>{this.props.pcd1}<br />{this.props.pcd2}</span>;
        }

        if (this.props.delivery_time) {
            deliveryTime = <div className="delivery-time"><span>Toimitusaika&nbsp;{this.props.delivery_time}</span></div>;
            countAvailable = 1000;
        }

        var addBtnClass = this.state.count ? '' : 'disabled',
            hasImg = !this.props.thumbnail,
            imgSrc = hasImg ? '/static/nettivanne/webshop/img/rengas.svg' : this.props.thumbnail,
            imgClass = !hasImg ? '' : 'no-pic';

        return (
            <div className="product-box wheel">
              <div className="left-container">
                  <div className="img">
                      <a href={this.props.url} onClick={this.handleProductClick}>
                        <LazyImage className={imgClass}
                             alt={this.props.brand + " " + this.props.model + " tuotekuva "}
                             src={imgSrc} />
                      </a>
                      {this.props.near_top && <div className="highlight-product"></div>}
                      <div className="size">{this.props.size}"</div>
                  </div>
                  <div className="product-name">
                      <a href={this.props.url} onClick={this.handleProductClick}>
                          <div className="brand">{this.props.brand}</div>
                          <div className="model">{this.props.model}{" "}{this.props.title_extra}</div>
                      </a>
                      <div className="details">
                          <span className="is-wheel-set">{wheel_set_text}</span>
                          <span className="details-mobile">
                              {this.props.size}x{this.props.width}{" "}
                              {this.props.pcd}{" "},
                          </span>
                          <div>{this.props.is_blank && <b>BLANK</b>} Leveys: {this.props.width}", pulttijako: {pcd}, ET{this.props.et}, keskireikä: Ø{this.props.bore}</div>
                          {this.props.non_stock_product && <span>TILAUSTUOTE</span>}
                          {deliveryTime}
                      </div>
                  </div>
              </div>
              <ProductHelpers.ItemCountControl count={this.state.count}
                                               unitPrice={this.props.unit_price}
                                               interval={interval}
                                               max={countAvailable}
                                               isWheelset={is_wheel_set}
                                               pricePerText={is_wheel_set ? 'sarja':'kpl'}
                                               pricePerTextPlural={is_wheel_set ? 'sarjaa':'kpl'}
                                               onChange={this.handleCountChange} />
              {this.renderAddToCart()}
            </div>
        );
    },
    handleProductClick: function(e) {
        e.preventDefault();
        const urlTarget = this.props.url;
        dataLayer.push({
            'event': 'ecomProductClick',
            'ecommerce': {
              'currencyCode': 'EUR',
              'click': {
                'actionField': {'list': getCurrentPageName()},
                'products': [{
                    'name': this.props.brand + ' ' + this.props.model,
                    'id': this.props.id,
                    'price': this.props.unit_price,
                    'brand': this.props.brand,
                    'category':
                      `${this.props.wheel_type == 'alloy' ? 'Alumiinivanteet' : 'Peltivanteet'}${this.props.used ? ' käytetyt' : ''}`,
                    'position': this.props.position,
                 }]
               }
             },
             'eventCallback': function() {
                document.location = urlTarget;
             }
        });
    }
});

export default WheelList;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/wheel-list.js
 **/